<template>

    <div>
        <label for="coupon">Promo Code (optional)</label>

        <div class="input-group">
            <input type="text" name="coupon" id="coupon" placeholder="Code" autocomplete="bb-coupon" maxlength="20" ref="coupon" :value="value" @input="updateInput()">

            <div class="input-group-append">
                <button class="btn btn-secondary" type="button" @click="checkCoupon">Apply</button>
            </div>
        </div>

        <span class="d-block input-requirement" :class="[status]">{{ message }}</span>
    </div>

</template>
<script>
    export default {
        name: "CouponFinder",

        props: ['value'],

        data() {
            return {
                status: '',
                message: '',
                statues: {
                    // These correspond to class names
                    DEFAULT: '',
                    SUCCESS : 'success',
                    ERROR: 'error',
                    PENDING: 'pending',
                }
            }
        },

        mounted() {
            this.$data.status = this.$data.statues.DEFAULT;
        },

        methods: {

            checkCoupon() {
                if(this.$refs.coupon.value) {

                    let coupon = this.$refs.coupon.value.replace(/\s/g, '');

                    axios.post('/handlers/coupon', {
                        coupon: coupon
                    })
                    .then(request => {
                        this.$data.message = request.data.message;
                        this.$data.status = this.$data.statues.SUCCESS;
                    })
                    .catch(error => {
                        if(error.response) {
                            this.$data.message = error.response.data.message;
                        } else {
                            this.$data.message = 'Server could not be reached';
                        }
                        this.$data.status = this.$data.statues.ERROR;
                    });
                }
            },

            updateInput() {
                this.$data.status = this.$data.statues.DEFAULT;
                this.$data.message = '';
                this.$emit('input', this.$refs.coupon.value);
            }
        }
    }
</script>